import { render, staticRenderFns } from "./HeritageDetailEng.vue?vue&type=template&id=2441445d&"
import script from "./HeritageDetailEng.vue?vue&type=script&lang=js&"
export * from "./HeritageDetailEng.vue?vue&type=script&lang=js&"
import style0 from "./HeritageDetailEng.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports